import React from 'react';

import { Container, ContainerProps as CardGlobalProps } from './styles';

const CardGlobal: React.FC<CardGlobalProps> = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

export default CardGlobal;
